import { EXTEND_CERTIFIED_LABEL } from "../../../../infecto-lms-webapp-impl/i18n/extendIsCertifiedLabel.i18n";

export const CERTIFIED_LABEL: { [key: string]: string } = {
	...EXTEND_CERTIFIED_LABEL,
};
